<template>
  <v-container>
    <v-card
      flat
      justify="center"
      v-for="(question, index) in faqList"
      :key="index"
      class="mb-2"
      @click="goToVideo(index)"
    >
      <v-card-text class="black--text">{{ question }}</v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      linkId: "",
      faqList: [
        "¿Cómo instalar Solena Explore en iOS (iPhone)",
        "¿Cómo iniciar sesión?",
        "¿Dónde ver el detalle de una muestra?",
        "¿Cómo crear una entrada en bitácora sobre un área?",
        "¿Cómo crear manejo agronómico en un área?",
      ],
    };
  },
  created() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),

    goToVideo(index) {
      this.$router.push({
        path: `/help-video/${index}`,
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.video-responsive {
  position: relative;
  padding-bottom: 80%;
  padding-top: 70%;
  width: 100%;
  overflow: hidden;
}

.video-responsive iframe,
.video-responsive object,
.video-responsive embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media only screen and (min-width: 540px) {
  .video-responsive {
    padding-bottom: 55%;
    padding-top: 60%;
  }
}
</style>
